import React from 'react';

import Callout from 'js/src/components/common/ui/Callout';

interface DurationWarningProps {
    show: boolean;
}

const DurationWarning: React.FC<DurationWarningProps> = ({ show }) => {
    if (!show) {
        return null;
    }

    return <Callout className="mb-l5-0" text="You are about to reach your recording limit." />;
};

export default React.memo(DurationWarning);
